module.exports = __webpack_public_path__ + "static/media/iphone1.767d5b4e.png";